import { createContext } from 'react';

import type { SemanticHeadingBaseLevel } from './SemanticHeading.types';

const SemanticHeadingBaseLevelContext = createContext<SemanticHeadingBaseLevel>(0);

export default SemanticHeadingBaseLevelContext;
